export enum PaymentProcessEnum {
  BEGIN = 'BEGIN',
  FAILED = 'FAILED',
  END = 'END',
}
